import moment from '@Utils/date/moment';
import { Moment } from 'moment';

export default (timestamp: number): Moment => {
	const nowTimestamp = moment().valueOf();
	return moment(nowTimestamp + timestamp);
};
